/**
 * Maps URL / i18n language codes to locale IDs used by FullCalendar and Luxon.
 */
export function isRtlLocale(appLng) {
  const base = (appLng || 'en').split('-')[0];
  return base === 'he' || base === 'ar';
}

export function fullCalendarLocale(appLng) {
  if (!appLng) return 'en';
  if (appLng === 'zh') return 'zh-cn';
  return appLng;
}

export function fullCalendarDirection(appLng) {
  return isRtlLocale(appLng) ? 'rtl' : 'ltr';
}

export function luxonLocale(appLng) {
  if (!appLng) return 'en';
  if (appLng === 'zh') return 'zh-CN';
  return appLng;
}
